export const APP_LOGO_TOP_BAR_HEIGHT = '64px';
